import { dictionary } from 'common/language/dictionary';
import { I18nNamespace } from 'common/language/namespace';

export const ProjectSelectI18n = {
  configuration: { namespace: I18nNamespace.PROJECT_SELECT, labelKey: 'label' },
  translations: {
    label: dictionary.project,
    placeholder: dictionary.selectProject,
    noOptions: dictionary.noOptions,
    filterPlaceholder: dictionary.filter,
    clear: dictionary.clear,
    save: dictionary.save,
  },
};
